import React from 'react';
import { observer, inject } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import Header from 'apps/components/header/header';
import { MainWrapper } from 'legacyComponents/styled/lib';
import { CardSection } from 'legacyComponents/layout/cardSection';
import { IssueCard } from 'legacyComponents/cards/types/issue';

import CommunityTasksManager from 'apps/home/community/tasks/appManager';

type CommunityTasksProps = {
  t: (text: string) => string;
};

@withNamespaces()
@inject('routerStore')
@observer
export default class CommunityTasks extends React.Component<CommunityTasksProps> {
  [x: string]: any;
  UNSAFE_componentWillMount() {
    this.appManager = new CommunityTasksManager(null, this.props);
  }

  render() {
    const { t } = this.props;
    const connection = this.appManager.issuesConn;
    const issues = connection.arrayApp;
    return (
      <>
        <Header />
        <MainWrapper>
          <CardSection
            invisible={this.appManager.loading}
            title={t('Open Tasks')}
            subTitle=' '
            ownerName=''
            cardApp={issues}
            canShowNoDataCard={!issues?.length}
            CardComponent={IssueCard}
            noDataCardType='issue'
          />
        </MainWrapper>
      </>
    );
  }
}
